import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/styles/makeStyles';
import type { Theme } from '@material-ui/core';
import MailOutlineSharp from '@material-ui/icons/MailOutlineSharp';

import useLazyFetch from '../hooks/useLazyFetch';

const useStyles = makeStyles<Theme>(({ palette, spacing, typography }) => ({
  container: {
    textAlign: 'center',
  },
  form: {
    margin: spacing(5, 0, 2),
  },
  paper: {
    display: 'flex',
    margin: '0 auto',
    width: '100%',
    maxWidth: 600,
    alignItems: 'stretch',
  },
  textField: {
    '& p': {
      fontSize: typography.caption.fontSize,
      left: spacing(-2),
      lineHeight: 1,
      position: 'absolute',
      top: '100%',
      width: '100%',

      '&.Mui-error': {
        color: palette.common.white,
      },
    },
  },
  button: {
    flexShrink: 0,
  },
  progress: {
    marginLeft: spacing(1),
  },
}));

const formAction = 'https://app.convertkit.com/forms/1811413/subscriptions';

const SubscribeForm: React.FC = ({}) => {
  const classes = useStyles();
  const [values, setValues] = useState({
    email_address: '',
    user: '',
    token: '',
    tags: [],
  });
  const [fetchData, { loading, error, response }] = useLazyFetch(formAction);
  const isError = Boolean(error) || response?.status === 'failed';
  const isSuccess = response?.status === 'success';
  const errorMsg =
    response?.errors?.messages?.[0] ?? 'Request failed. Try again!';

  return (
    <div className={classes.container}>
      <Typography variant="h4" gutterBottom>
        {!isSuccess ? 'Join the Newsletter' : 'Cool, almost there...'}
      </Typography>
      {!isSuccess && (
        <Typography variant="body1" gutterBottom>
          Subscribe to be up to date by email. <br /> Cool content and no spam.
        </Typography>
      )}
      {isSuccess && (
        <Typography variant="body1" gutterBottom>
          I sent you a confirmation email to <b>{values.email_address}</b>.
          Please check it out!
        </Typography>
      )}
      {!isSuccess && (
        <form
          action={formAction}
          method="POST"
          name="subscribe"
          onSubmit={(e) => {
            e.preventDefault();
            fetchData(values);
          }}
          className={classes.form}
        >
          <Paper className={classes.paper}>
            <TextField
              className={classes.textField}
              color="secondary"
              error={isError}
              fullWidth
              helperText={isError ? errorMsg : null}
              id="email_address"
              label="Email"
              name="email_address"
              required
              type="email"
              value={values.email_address}
              variant="filled"
              onChange={({ target }) =>
                setValues((state) => ({
                  ...state,
                  [target.name]: target.value,
                }))
              }
            />
            <Button
              className={classes.button}
              color="default"
              size="large"
              type="submit"
              disabled={!values.email_address || loading}
            >
              Subscribe
              {loading && (
                <CircularProgress
                  size={25}
                  color="secondary"
                  className={classes.progress}
                />
              )}
            </Button>
          </Paper>
        </form>
      )}
      {isSuccess && <MailOutlineSharp fontSize="large" />}
    </div>
  );
};

export default SubscribeForm;
